<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <table class="table" style="background-color:white;">

    <tr>
      <td style="background-color:brown;color:white;" colspan="2">Change Password</td>
      <td style="text-align: right;background-color: brown;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
    </tr>
  </table>



  <form (ngSubmit)="changePassword(changePasswordForm.value)" [formGroup]="changePasswordForm">

    <div class="container">
      <mat-form-field class="col-lg-4">
        <input type="password" matInput placeholder="Current Password" formControlName="CurrentPassword" maxlength="20" minlength="8" required />
        <mat-error *ngIf="submitted && f.CurrentPassword.errors">
          Enter Current Password
        </mat-error>
      </mat-form-field>


      <mat-form-field class="col-lg-4">
        <input type="password" matInput placeholder="New Password" formControlName="NewPassword" maxlength="20" minlength="8" required />
        <mat-error *ngIf="submitted && f.NewPassword.errors?.required">
          Enter New Password
        </mat-error>
        <mat-error *ngIf="f.NewPassword.hasError('pattern')">
          New Password must contain a minimum of 8 characters which should include 1 alpha numeric, 1 upper case letter, 1 lower case letter & 1 special character(eg:Ghan@233)
        </mat-error>
      </mat-form-field>

      <mat-form-field class="col-lg-4">
        <input type="password" matInput placeholder="Confirm Password" formControlName="ConfirmPassword" maxlength="20" minlength="8" required />
        <mat-error *ngIf="submitted && f.ConfirmPassword.errors?.required">
          Enter Confirm Password
        </mat-error>
        <mat-error *ngIf="f.ConfirmPassword.hasError('pattern')">
          Confirm Password must contain a minimum of 8 characters which should include 1 alpha numeric, 1 upper case letter, 1 lower case letter & 1 special character(eg:Ghan@233)
        </mat-error>
        <mat-error *ngIf="f.ConfirmPassword.hasError('confirmPasswordValidator')">New Password and Confirm Password must be match</mat-error>

      </mat-form-field>
      <div>&nbsp;&nbsp;</div>

      <div class="text-center">
        <button type="submit" mat-raised-button color="primary" class="col-lg-3" style="margin-top: 20px;background-color:#f44a4a;color:white !important;">Submit</button>


      </div>


    </div>

  </form>


</fieldset>



